import type { Theme } from '@emotion/react'
import { css, keyframes } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

export const continueButton = (theme: Theme) => css`
  ${breakpoint.down('sm')} {
    width: 100%;
  }

  &:not(:last-child) {
    ${breakpoint.up('md')} {
      margin-right: ${theme.spacing[16]};
    }

    ${breakpoint.down('sm')} {
      margin-bottom: ${theme.spacing[16]};
    }
  }
`

export const fullWidth = (theme: Theme) => css`
  margin-right: 0;

  &:not(:last-child) {
    margin-bottom: ${theme.spacing[16]};
  }
`

export const noMargin = css`
  margin-right: 0;

  &:not(:last-child) {
    margin-bottom: 0;
  }
`

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`

export const floatingContainer = (theme: Theme) => css`
  ${breakpoint.up('md')} {
    position: fixed;
    bottom: 0;
    left: 0;
    right: auto;
    /* Match CssBaseline's viewport width, including any desktop scrollbar. */
    width: 100vw;
    display: flex;
    justify-content: center;
    padding: ${theme.spacing[16]} 0;
    padding-bottom: calc(${theme.spacing[16]} + env(safe-area-inset-bottom, 0px));
    background: transparent;
    animation: ${slideUp} 200ms cubic-bezier(0, 0, 0.2, 1) both;

    > button {
      width: 100%;
      max-width: 512px;
    }
  }

  ${breakpoint.down('sm')} {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ${theme.spacing[16]};
    padding-bottom: calc(${theme.spacing[16]} + env(safe-area-inset-bottom, 0px));
    background: ${theme.palette.background.main};
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    animation: ${slideUp} 200ms cubic-bezier(0, 0, 0.2, 1) both;
  }
`
